module.exports = __webpack_public_path__ + "media/landing_page/success-check-e730ff1c.svg";